import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "product-navigation" }
const _hoisted_2 = {
  key: 0,
  class: "product-navigation__row"
}
const _hoisted_3 = {
  key: 0,
  class: "product-navigation__row product-navigation__row--nav"
}
const _hoisted_4 = { class: "product-navigation__wrapper" }
const _hoisted_5 = ["href", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sale_box_bar = _resolveComponent("sale-box-bar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["product-navigation__container", {'product-navigation__container--sticky': _ctx.stickyState}]),
      ref: "productNavigationElement"
    }, [
      _createVNode(_Transition, { name: "product-navigation--animation-row" }, {
        default: _withCtx(() => [
          (_ctx.stickyState)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_sale_box_bar, {
                  class: "product-navigation__sale-box",
                  "one-page-checkout": _ctx.onePageCheckout
                }, null, 8 /* PROPS */, ["one-page-checkout"])
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }),
      _cache[0] || (_cache[0] = _createTextVNode()),
      (_ctx.showNavi)
        ? (_openBlock(), _createElementBlock("nav", _hoisted_3, [
            _createElementVNode("ul", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (section, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  (_ctx.getSectionText(section).length > 0)
                    ? (_openBlock(), _createElementBlock("li", {
                        key: index,
                        class: "product-navigation__item"
                      }, [
                        _createElementVNode("a", {
                          href: _ctx.getSectionUrl(section),
                          onClick: _withModifiers(($event: any) => (_ctx.scrollTo(section)), ["prevent"]),
                          class: _normalizeClass(["product-navigation__link", { 'product-navigation__link--active': section === _ctx.currentSection }])
                        }, _toDisplayString(_ctx.getSectionText(section)), 11 /* TEXT, CLASS, PROPS */, _hoisted_5)
                      ]))
                    : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
              }), 256 /* UNKEYED_FRAGMENT */))
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */)
  ]))
}